// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const ChecklistOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"viewBox":"0 0 48 48","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M0 0h48v48H0z","fill":"none"}},{"tag":"path","attrs":{"d":"M8 10h18V6H4v36h26v-4H8zM32 34.7l6 7.5 6-7.5V6H32v28.7zm6 1.1l-2-2.5V18h4v15.3l-2 2.5zM40 10v4h-4v-4h4z"}},{"tag":"path","attrs":{"d":"M21 13.86l-3.77 3.77-1.89-1.89-2.82 2.83 4.7 4.71 6.6-6.6zM15.34 25.74l-2.82 2.83 4.7 4.71 6.6-6.6L21 23.86l-3.77 3.77z"}}]},"name":"checklist","theme":"outlined"};

const ChecklistOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={ChecklistOutlinedSvg} />;
  ChecklistOutlined.displayName = 'ChecklistOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(ChecklistOutlined);
